/**
 * Public marketing site (sites/www) - changelog, landing, help, etc.
 * Prod default: https://maater.com. Local preview: npm run site:preview (port 4177).
 */
const DEFAULT_PUBLIC_SITE_URL = 'https://maater.com'
/** Prefer Traefik host (www-proxy → :4177); fallback still works via localhost:4177. */
const LOCAL_PUBLIC_SITE_URL = 'http://maater.localhost'

function trimTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '')
}

/** Origin for maater.com (or local static preview). */
export function getPublicSiteOrigin(): string {
  const fromEnv = import.meta.env.VITE_PUBLIC_SITE_URL?.trim()
  if (fromEnv) return trimTrailingSlash(fromEnv)
  if (import.meta.env.DEV) return LOCAL_PUBLIC_SITE_URL
  return DEFAULT_PUBLIC_SITE_URL
}

export function getPublicChangelogUrl(): string {
  return `${getPublicSiteOrigin()}/changelog/`
}

export function getPublicChangelogFeedUrl(): string {
  return `${getPublicSiteOrigin()}/changelog/feed.xml`
}

/**
 * Public help guides under /help/.
 * @param path optional subpath, e.g. "mobile", "/mobile/", "feedback"
 * Mobile is not under /help/ - `mobile` resolves to the durable /mobile/ invite page.
 */
export function getPublicHelpUrl(path?: string): string {
  const base = `${getPublicSiteOrigin()}/help/`
  if (!path) return base
  const cleaned = path.replace(/^\/+/, '').replace(/\/+$/, '')
  if (!cleaned || cleaned === 'help') return base
  if (cleaned === 'mobile') return getPublicMobileBetaUrl()
  return `${base}${cleaned}/`
}

/** Durable mobile beta invite URL (QR + setup; redirects to /beta/mobile/). */
export function getPublicMobileBetaUrl(): string {
  return `${getPublicSiteOrigin()}/mobile/`
}
